export default function About(){
    return (
    
<section id="about">
      <div className="container">
      <h2>About Us</h2>
        <p>
        Kidzee Preschool is a leading chain of preschools located in India and Nepal backed by Zee Learn Ltd. With more than two decades of experience in the preschool industry, Kidzee has nurtured more than 1.5 million children throughout India. Being one of the largest preschools in India. Kidzee has 2000+ centres in 750+ cities in India and Nepal.
        </p>
      </div>
    </section>

    );

}